"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  empty: '无结果',
  unit: '条'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/sharedComponents/Search/locale/zh_CN.js
// module id = 1671
// module chunks = 6 7 17 18